<fa-icon
    [icon]="faExclamationTriangle"
    *ngIf="notification.isEscalated && showEscalatedIcon"
    class="me-1 red"
></fa-icon>
<fa-icon [icon]="faBan" *ngIf="notification.isCancelled && showCancelledIcon" class="me-1 red"></fa-icon>
<fa-icon [icon]="faCircle" *ngIf="notification.isUnread && showUnreadIcon" class="me-1 orange"></fa-icon>
<fa-icon [icon]="faStopCircle" *ngIf="notification.isPaused && showPausedIcon" class="me-1 orange"></fa-icon>
<span *ngIf="showBadge" class="badge-text" [ngClass]="statusClass">{{ statusText }}</span>
